import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppForm from '@core/components/AppForm.vue'
import ReportDashboardComponent from './component/ReportDashboardComponent.vue'
import { ReportDTO, ReportManagementService, ReportSearchDTO } from './api'
import { ReportSearchRequest } from './model/ReportSearchRequest'
import { IDateService } from '@master/services/IDateService'
import { inject } from 'inversify-props'
import { CompanyDetailsMeta } from '../companyDetails/model/CompanyDetailsMeta'
import API from '@core/services/API'
import { ClientPolicyReportRequestDTO, ClientPolicyService } from '../new-business-register/api'
import { SharedVariable } from '@core/model/SharedVariable'
import { UIService } from '@core/services/UIService'
import { PicodedAccountDTO, UserMemberService } from '../account/api'
import { sortBy } from 'lodash'
import { base64ToBlob } from '@core/tools/documents'

type Tab = 'dashboard' | 'report-list'

@Component({
  components: {
    AppDatatable,
    AppForm,
    ReportDashboardComponent
  }
})
export class ReportManagementMixin extends Vue {
  // listOfReports: any[] = []
  reportSearchDto: ReportSearchDTO = new ReportSearchRequest()
  reportList = true
  currentDatatablePage = 1

  private userList: PicodedAccountDTO[] = []
  private companyList: CompanyDetailsMeta[] = []

  @inject()
  private $api: API

  @inject()
  dateService: IDateService

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  tab = 'dashboard'

  // get list () {
  //   return this.listOfReports
  // }

  get columns (): {label: string; field: keyof ReportDTO}[] {
    return [
      { label: 'Name', field: 'name' },
      { label: 'Module', field: 'module' },
      { label: 'Created By', field: 'createdBy' },
      { label: 'Created At', field: 'ctm' },
      { label: 'Status', field: 'status' }
    ]
  }

  changeTab (event: Event, tab: Tab): void {
    const div = event.target as HTMLDivElement
    if (div.classList.contains('active')) {
      return
    }
    this.tab = tab
    this.currentDatatablePage = 1
    this.updateRouterQuery({ tab: tab, page: this.currentDatatablePage })
    this.updateTable()
  }

  updateTable () {
    // Do nothing for now
  }

  updateRouterQuery (newQuery) {
    const query = Object.assign({}, this.$route.query)
    delete query.redirect_uri
    this.$router.replace({ query: { ...query, ...newQuery } })
    // this.updateDatatablePage()
  }

  // updateDatatablePage () {
  //   if (this.tab === 'dashboard') return
  //   this.fetchData()
  // }

  async downloadReport (data, fileName) {
    const link = document.createElement('a')
    link.href = base64ToBlob(data)
    link.download = fileName + '.pdf'
    link.click()
    link.remove()
  }

  // async fetchData () {
  //   const res = await ReportManagementService.listReports(this.reportSearchDto)
  //   this.listOfReports = res.map(report => {
  //     return {
  //       ...report,
  //       emit: true,
  //       ctm: this.dateService.format(report.ctm, 'DD/MM/YYYY')
  //     }
  //   })
  // }

  get companyOptions () {
    return sortBy(this.companyList.map(company => {
      return {
        label: company.companyDetailsName,
        value: company.oid
      }
    }), company => company.label)
  }

  get adviserOptions () {
    return sortBy(this.userList.map(user => {
      return {
        label: user.fullname,
        value: user.oid,
        systemRole: user.systemrole
      }
    }), user => user.label)
  }

  async fetchUsers () {
    const accounts = await UserMemberService.listAllUserAccountBasedOnHierarchy({})

    this.userList = accounts
  }

  async fetchCompanies () {
    const queryHeader = ['_oid', 'company_details_name']
    const res: { data: Array<any[]> } = await this.$api.companyDetails.list({
      headers: JSON.stringify(queryHeader)
    })

    this.companyList = res.data.map(companyMeta => {
      const company = new CompanyDetailsMeta()
      company.assignData(queryHeader, companyMeta)
      return company
    })
  }

  async generateReport (reportRequest: ClientPolicyReportRequestDTO) {
    this.uiService.loading.addLoadingTask('generating-policy-report')
    try {
      const report = await ClientPolicyService.generateAdhocReports(reportRequest)
      if (!report) {
        this.uiService.alert.show({
          type: 'error',
          message: 'Unable to generate report. Please contact administrator.'
        })
      }
      if (report.status === 'READY') {
        this.uiService.alert.show({
          type: 'success',
          message: `${report.name} generated.`
        })
        this.downloadReport(report.data, report.name)
        return
      }

      if (report.status === 'ERROR') {
        this.uiService.alert.show({
          type: 'error',
          message: 'Report generated without file to download.'
        })
      }
    } catch (error) {
      this.uiService.alert.show({
        type: 'error',
        message: error.message || 'Encounter error while trying to generate report.'
      })
    } finally {
      this.uiService.loading.removeLoadingTask('generating-policy-report')
    }
  }

  async mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService
    this.uiService.loading.addLoadingTask('report-management')
    try {
      // await this.fetchData()
      await this.fetchUsers()
      await this.fetchCompanies()
    } finally {
      this.uiService.loading.removeLoadingTask('report-management')
    }
  }
}
